// eslint-disable-next-line import/no-cycle
import qs from 'query-string';
import { request, requestEdm } from './index';
import { ChannelResponse, EmailVerificationCodeRequest, EmailVerificationCodeRequestV2, EmailVerificationCodeResponse } from './interface/pinyin-class';
import {
  EventTrackingReq,
  EventTrackingRes,
  GenerateSchemeRes,
  GenerateSchemeReq,
  ClueTrackInfoReq,
  ClueTrackInfoRes,
  StudentInfoRes,
  ITrackInfoReq,
  ITrackInfoReS,
  User,
  IRepeatActiveAndIntentionReq,
  IRepeatActiveAndIntentionRes,
  GeStudentInfoRes,
  GeStudentInfoResContent,
} from './interface/common';

export const getCountry = () => {
  return request.post('/public/reserve/country/info');
};

export const getCountryNew = (data?: { showChinaDomestic?: boolean }) => {
  return request.post(
    qs.stringifyUrl({
      url: '/public/reserve/country/v2',
      query: {
        ...data,
      },
    }),
  );
};

/**
 * 判断是否是新新线索
 *
 * @param {{ email: string; subject: string ; mobile?:string; }} data 邮箱与科目
 * @return {*}
 */
export const getUser = (data: {
  email: string;
  subject: string;
  studentCode: string;
  mobile?: string;
  returnTrackExistsInAnySubject?: boolean;
}) => {
  return request.post<User, User>('/public/track/isNew', data);
};

/**
 * 判断是否是新新线索 - 激活拓科专用接口
 *
 * @param {{ email: string; subject: string ; mobile?:string; trackId?:string; }} data 邮箱与科目
 * @return {*}
 */
export const getUserForActiveExpandReserve = (data: {
  email: string;
  subject: string;
  studentCode: string;
  mobile?: string;
  trackId?: string;
  payload?: any;
  lead?: string;
}) => {
  return request.post<User, User>('/public/track/isNew/active-expand-reserve', data);
};

// 获取时间 public/timestamp
export const getTimestamp = () => {
  return request.get<number, number>(`/public/timestamp`);
};

// 邮箱、手机号解密
export const getDeCode = (code: string) => {
  return request.get<string, string>(`/public/track/transCode/decode/${code}`);
};

export const createLead = (data: any) => {
  return getTimestamp().then((res) => {
    return request.post('/public/lead/create', data, {
      signature: true,
      timestamp: res,
    });
  });
};

/**
 * 补全二娃邮箱、手机号信息
 * @param data 
 * @returns 
 */
export const completeTwoChildInfo = (data: {
	trackId: string;
	refStudentCode: string;
	refTrackId: string;
}) => {
  return request.post('/public/childTrackInfo', data);
};

export const createLeadNoRemind = (data: any) => {
  return getTimestamp().then((res) => {
    return request.post('/public/lead/create', data, {
      signature: true,
      timestamp: res,
      skipErrorHandler: true,
    });
  });
};

// 约课进线接口修改

export const createLeadNoRemindNew = (data: any) => {
  return getTimestamp().then((res) => {
    return request.post('/public/rs/lead/create', data, {
      signature: true,
      timestamp: res,
      skipErrorHandler: true,
    });
  });
};

// 发送邮箱验证码
export const sendEmailVerificationCode = (data: EmailVerificationCodeRequest) => {
  return request.put('/public/email/send', data);
};

// 验证邮箱验证码
export const verifyEmailVerificationCode = (data: EmailVerificationCodeRequest) => {
  return request.post<EmailVerificationCodeResponse, EmailVerificationCodeResponse>('/public/email/verification', data);
};

// 验证邮箱验证码V2
export const verifyEmailVerificationCodeV2 = (data: EmailVerificationCodeRequestV2) => {
  return request.post<EmailVerificationCodeResponse, EmailVerificationCodeResponse>('/public/email/v2/verification', data);
};


export const getJsonNode = (id: string) => {
  return requestEdm.get<ChannelResponse, ChannelResponse>(`/public/ref/json_node/${id}`);
};

export const sendPosterReportEvent = (data: any) => {
  return requestEdm.post<ChannelResponse, ChannelResponse>(`/public/poster/center/scanqr/data`, data);
};

export const sendEventTracking = (params: EventTrackingReq) => {
  return request.post<EventTrackingRes, EventTrackingRes>(`/public/eventTracking/upload`, {
    ...params,
  });
};

// 获取小程序scheme码

export const getGenerateScheme = (params: GenerateSchemeReq) => {
  return request.get<GenerateSchemeRes, GenerateSchemeRes>(`/public/api/wechat/share/generateScheme`, { params });
};
// 查询当前手机号 或者邮箱 是否是新老线索
export const getClueTrackInfo = (params: ClueTrackInfoReq) => {
  return request.post<ClueTrackInfoRes, ClueTrackInfoRes>(`/public/poster/center/track/info/data`, {
    ...params,
  });
};
// 通过学号获取学生剩余课时，所有天数

export const getStudentDayAndClass = (params: any) => {
  return request.post<StudentInfoRes, StudentInfoRes>(`/public/lead/student_learning/${params}`);
};

// 通过参数查询信息 如学号等
export const getTrackInfo = (params: ITrackInfoReq) => {
  return request.post<ITrackInfoReS, ITrackInfoReS>(`/public/track/info`, {
    ...params,
  });
};

// 生成市场活动记录
export const repeatActive = (params: { trackId: string; leadId: string; payload: any }) => {
  return requestEdm.post('/public/lead/repeatActive/', params);
};

// 一键激活+拓科
export const repeatActiveAndIntention = (params: IRepeatActiveAndIntentionReq) => {
  return requestEdm.post<IRepeatActiveAndIntentionRes, IRepeatActiveAndIntentionRes>(
    '/public/lead/repeatActiveAndIntention',
    params,
  );
};

// 脱敏版本一键激活+拓科
export const repeatActiveAndIntentionMasked = (params: IRepeatActiveAndIntentionReq) => {
  return requestEdm.post<IRepeatActiveAndIntentionRes, IRepeatActiveAndIntentionRes>(
    '/public/lead/v2/repeatActiveAndIntention',
    params,
  );
};


// 生成微信二维码
export const getWxQrCode = (longLink: string, query: string) => {
  return request.post<string, string>(
    `/public/api/wechat/share/getAppletQRCodeTxt`,
    { page: longLink, scene: query },
    {
      needAuth: true,
    },
  );
};

// 生成微信二维码 改版
export const getWxQrCodeV2 = (page: string, longLink: string) => {
  return request.post<string, string>(
    `/public/api/wechat/share/v2/getAppletQRCodeTxt`,
    { page, longLink },
    {
      needAuth: true,
    },
  );
};


/**
 * 通过学号或trackId获取学生信息
 * @param code 学号或trackId
 * @param type 学号或trackId
 * @returns 学生信息
 */
export const getStudentInfo = (code: string, type: 'trackId' | 'studentCode', subject?: string) => {
  return request.get<GeStudentInfoRes, GeStudentInfoRes>(`/public/getTrackInfo?${type}=${code}${subject ? `&subject=${subject}` : ''}`).then((res) => {
    return res.content;
  });
};

